import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  getProductVariant,
  createProductVariant,
  deleteProductVariant,
  updateProductVariant,
} from "data/server_apis/commodityService";

const productVariantAdapter = createEntityAdapter({
  selectId: (productVariant) => productVariant.id,
});

export const getVariantsForProductThunk = createAsyncThunk(
  "productVariant/getForProduct",
  async (id, { rejectWithValue }) => {
    try {
      return (await getProductVariant(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const createProductVariantThunk = createAsyncThunk(
  "productVariant/create",
  async (data, { rejectWithValue }) => {
    try {
      return (await createProductVariant(data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const updateProductVariantThunk = createAsyncThunk(
  "productVariant/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      return (await updateProductVariant(id, data)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

export const deleteProductVariantThunk = createAsyncThunk(
  "productVariant/delete",
  async (id, { rejectWithValue }) => {
    try {
      return (await deleteProductVariant(id)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const productVariantSlice = createSlice({
  name: "productVariants",
  initialState: productVariantAdapter.getInitialState({
    loading: {},
    error: {},
    errorMessage: {},
    success: {},
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVariantsForProductThunk.pending, (state, action) => {
        state.loading = { get: action.meta.arg };
        state.error = {};
        state.errorMessage = {};
        state.success = {};
      })
      .addCase(getVariantsForProductThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { get: action.meta.arg };
        state.errorMessage = { get: action.payload?.message };
        state.success = {};
      })
      .addCase(getVariantsForProductThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.errorMessage = {};
        state.success = { get: action.payload?.message };
        productVariantAdapter.setAll(state, action.payload.results);
      });

    builder
      .addCase(createProductVariantThunk.pending, (state, action) => {
        state.loading = { create: action.meta.arg.product };
        state.error = {};
        state.errorMessage = {};
        state.success = {};
      })
      .addCase(createProductVariantThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { create: action.meta.arg.product };
        state.errorMessage = { create: action.payload?.message };
        state.success = {};
      })
      .addCase(createProductVariantThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.errorMessage = {};
        state.success = { create: action.meta.arg.product };
        productVariantAdapter.addOne(state, action.payload);
      });

    builder
      .addCase(updateProductVariantThunk.pending, (state, action) => {
        state.loading = { update: action.meta.arg };
        state.error = {};
        state.errorMessage = {};
        state.success = {};
      })
      .addCase(updateProductVariantThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { update: action.meta.arg.id };
        state.errorMessage = { update: action.payload?.message };
        state.success = {};
      })
      .addCase(updateProductVariantThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.errorMessage = {};
        state.success = { update: action.payload?.message };
        productVariantAdapter.updateOne(state, {
          id: action.meta.arg.id,
          changes: action.payload,
        });
      });

    builder
      .addCase(deleteProductVariantThunk.pending, (state, action) => {
        state.loading = { delete: action.meta.arg };
        state.error = {};
        state.errorMessage = {};
        state.success = {};
      })
      .addCase(deleteProductVariantThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { delete: action.meta.arg };
        state.errorMessage = { delete: action.payload?.message };
        state.success = {};
      })
      .addCase(deleteProductVariantThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.errorMessage = {};
        state.success = { delete: action.meta.arg };
        productVariantAdapter.removeOne(state, action.meta.arg);
      });
  },
});
export const productVariantSelector = productVariantAdapter.getSelectors(
  (state) => state.productVariant
);
export const {} = productVariantSlice.actions;

export default productVariantSlice.reducer;
